import { useState } from "react";
import styles from "./styles.module.css";
import Campo from "../../../components/Campo";
import CampoTextoLongo from "../../../components/Campo/CampoTextoLongo";
import CampoSelect from "../../../components/Campo/CampoSelect";
import { Modalidade } from "../../../enums/Modalidade";
import { DescricaoDoProjeto } from "../../../model/PlanoDeTrabalho/DescricaoDoProjeto";
import CampoDate from "../../../components/Campo/CampoDate";
import VerificaForm from "../../../controllers/VerificaForm";
import { toIsoString } from "../../../controllers/Converters";

type Props = {
  passarPagina: Function;
  descricaoObj: DescricaoDoProjeto | undefined;
  setDescricao: React.Dispatch<
    React.SetStateAction<DescricaoDoProjeto | undefined>
  >;
  refEdital?: number;
};

function DescricaoProjeto({
  passarPagina,
  descricaoObj,
  setDescricao,
  refEdital,
}: Props) {
  const [titulo, setTitulo] = useState(descricaoObj ? descricaoObj.titulo : "");
  const [modalidade, setModalidade] = useState(
    descricaoObj?.modalidade ||
      (refEdital && Modalidade.colaboracao) ||
      Modalidade.fomento
  );
  const [edital_id, setEdital_id] = useState(
    descricaoObj?.edital_id || refEdital || undefined
  );
  const [areaAtendimento, setAreaAtendimento] = useState(
    descricaoObj?.areaAtendimento || ""
  );
  const [entidadeFinanciador, setEntidadeFinanciador] = useState(
    descricaoObj?.entidadeFinanciador || "PREFEITURA MUNICIPAL DE AQUIDAUANA"
  );
  const [objetoDaParceria, setObjetoDaParceria] = useState(
    descricaoObj?.objetoDaParceria || ""
  );
  const [descricaoDaRealidade, setDescricaoDaRealidade] = useState(
    descricaoObj?.descricaoDaRealidade || ""
  );
  const [formaExecucao, setFormaExecucao] = useState(
    descricaoObj?.formaExecucao || ""
  );
  const [metasQuantitativas, setMetasQuantitativas] = useState(
    descricaoObj?.descricaoMetasQuantitativas || ""
  );
  const [definicaoIndicadores, setDefinicaoIndicadores] = useState(
    descricaoObj?.definicaoIndicadores || ""
  );
  const [inicio, setInicio] = useState(
    descricaoObj?.prazoDeExecucao?.inicio || new Date(Date.now())
  );
  const [fim, setFim] = useState(
    descricaoObj?.prazoDeExecucao?.fim || new Date(Date.now())
  );

  return (
    <form className={styles.formCadastro} onSubmit={(e) => e.preventDefault()}>
      <div>
        <h2 className={styles.titulo}>
          1. Descreva o seu <strong>Projeto</strong> ou{" "}
          <strong>Atividade</strong>:
        </h2>
      </div>
      <div className={styles.gridCampos}>
        <Campo
          title="Titulo do Projeto/Atividade"
          type="text"
          placeholder="Digite o Titulo do seu Projeto ou Atividade"
          maxLength={64}
          required={true}
          customValidity="Preencha com o Titulo do seu Projeto"
          setter={setTitulo}
          value={titulo}
        />
        <div
          className={
            modalidade === Modalidade.colaboracao ? styles.gridCampos : ""
          }
        >
          <CampoSelect
            title="Modalidade"
            setter={setModalidade}
            value={modalidade}
          >
            <option value={Modalidade.fomento}>Termo de Fomento</option>
            <option value={Modalidade.colaboracao}>Termo de Colaboração</option>
            <option value={Modalidade.contribuicao}>
              Termo de Contribuição
            </option>
          </CampoSelect>
          {modalidade === Modalidade.colaboracao && (
            <Campo
              title="Numero do Edital"
              type="number"
              placeholder="Digite o numero do edital"
              required={modalidade === Modalidade.colaboracao}
              customValidity="Preencha com o numero do edital"
              setter={setEdital_id}
              value={edital_id}
            />
          )}
        </div>
        <Campo
          title="Órgão/Entidade Financiador"
          type="text"
          placeholder="Digite o nome do Órgão/Entidade Financiador"
          maxLength={64}
          required={true}
          customValidity="Preencha com o Órgão/Entidade Financiador"
          setter={setEntidadeFinanciador}
          value={entidadeFinanciador}
        />
        <Campo
          title="Objeto da Parceria"
          type="text"
          placeholder="Digite o Objeto da Parceria"
          maxLength={64}
          required={true}
          customValidity="Preencha com o Objeto da Parceria"
          setter={setObjetoDaParceria}
          value={objetoDaParceria}
        />
        <Campo
          title="Área de Atendimento"
          type="text"
          placeholder="Digite a Área de Atendimento do seu Projeto ou Atividade"
          maxLength={64}
          required={true}
          customValidity="Preencha com a Area de Atendimento"
          setter={setAreaAtendimento}
          value={areaAtendimento}
        />

        <div className={styles.gridCampos}>
          <CampoDate
            title="Inicio"
            showAsterisk
            customValidity="A data de inicio deve ser uma data valida e estar no futuro"
            min={new Date(Date.now()).toISOString().split("T")[0]}
            setter={setInicio}
            value={inicio}
          />
          <CampoDate
            title="Fim"
            showAsterisk
            customValidity="A data de Fim deve ser uma data valida e posterior a data de Inicio"
            min={toIsoString(inicio)}
            setter={setFim}
            value={fim}
          />
        </div>
      </div>
      <CampoTextoLongo
        title="Descrição da realidade"
        placeholder="Descreva a realidade do Projeto ou Atividade"
        required={true}
        customValidity="Preencha com a Realidade do Projeto/Atividade"
        setter={setDescricaoDaRealidade}
        value={descricaoDaRealidade}
      />
      <CampoTextoLongo
        title="Forma de Execução das Ações"
        placeholder="Descreva a forma que o Projeto ou Atividade sera Executada"
        required={true}
        customValidity="Preencha com a Forma de Execução do Projeto ou Atividade"
        setter={setFormaExecucao}
        value={formaExecucao}
      />
      <CampoTextoLongo
        title="Descrição de Metas Quantitativas"
        placeholder="Descreva as Metas Quantitativas do seu Projeto ou Atividade"
        required={true}
        customValidity="Preencha com a Descrição de suas Metas Quantitativas"
        setter={setMetasQuantitativas}
        value={metasQuantitativas}
      />
      <CampoTextoLongo
        title="Definição dos Indicadores"
        placeholder="Defina os Indicadores do seu Projeto ou Atividade"
        required={true}
        customValidity="Preencha com a efinição dos Indicadores do seu Projeto ou Atividade"
        setter={setDefinicaoIndicadores}
        value={definicaoIndicadores}
      />

      <div className="flex justify-end">
        <button
          className={styles.passarTelaBtn}
          onClick={(e) => {
            if (VerificaForm(e.currentTarget.form)) {
              setDescricao({
                titulo,
                modalidade,
                edital_id:
                  modalidade === Modalidade.colaboracao ? edital_id : undefined,
                areaAtendimento,
                entidadeFinanciador,
                prazoDeExecucao: {
                  inicio: inicio,
                  fim: fim,
                },
                objetoDaParceria,
                descricaoDaRealidade,
                formaExecucao,
                descricaoMetasQuantitativas: metasQuantitativas,
                definicaoIndicadores,
              });
              passarPagina();
            }
          }}
        >
          Salvar e Prosseguir ❯❯
        </button>
      </div>
    </form>
  );
}

export default DescricaoProjeto;
